import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import type { DrilldownConfig } from '../../../types/bi';
import styles from './DrilldownConfigEditor.module.css';

interface DrilldownConfigEditorProps {
  value: DrilldownConfig | null;
  onChange: (config: DrilldownConfig | null) => void;
  dimensions: string[];
}

export default function DrilldownConfigEditor({
  value,
  onChange,
  dimensions,
}: DrilldownConfigEditorProps) {
  const enabled = value !== null;

  const handleToggle = (checked: boolean) => {
    if (checked) {
      onChange({
        action: 'filter',
        target_field: dimensions[0] || '',
      });
    } else {
      onChange(null);
    }
  };

  return (
    <div className={styles.container}>
      <label className={styles.toggle}>
        <input type="checkbox" checked={enabled} onChange={(e) => handleToggle(e.target.checked)} />
        <span>Enable click drill-down</span>
      </label>

      {enabled && value && (
        <div className={styles.fields}>
          <div className={styles.field}>
            <label className={styles.label}>Action</label>
            <select
              className={styles.select}
              value={value.action}
              onChange={(e) =>
                onChange({ ...value, action: e.target.value as 'filter' | 'navigate' })
              }
            >
              <option value="filter">Filter dashboard</option>
              <option value="navigate">Navigate to page</option>
            </select>
          </div>

          <div className={styles.field}>
            <label className={styles.label}>
              Target field
              <span className={styles.hint}>
                <FontAwesomeIcon icon={faInfoCircle} />
                <span className={styles.hintText}>
                  {value.action === 'filter'
                    ? 'The field to filter by when clicking a data point'
                    : 'The field to pass as a query parameter'}
                </span>
              </span>
            </label>
            <select
              className={styles.select}
              value={value.target_field || ''}
              onChange={(e) => onChange({ ...value, target_field: e.target.value || undefined })}
            >
              <option value="">Auto (first dimension)</option>
              {dimensions.map((d) => (
                <option key={d} value={d}>
                  {d}
                </option>
              ))}
            </select>
          </div>

          {value.action === 'navigate' && (
            <div className={styles.field}>
              <label className={styles.label}>Target URL</label>
              <input
                className={styles.input}
                type="text"
                value={value.target_url || ''}
                onChange={(e) => onChange({ ...value, target_url: e.target.value || undefined })}
                placeholder="/cases"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
